import React, { memo, useMemo } from "react";
import Paper from "@mui/material/Paper";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import { ENTITY_TYPES } from "../../../utils";

const NoResultPaperSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "10px",
  color: "rgba(0, 0, 0, 0.6)",
  fontSize: "14px",
  fontWeight: 600,

  "& .result-msg": {
    paddingTop: "3px",
    paddingLeft: "3px",
  },
};

function CustomNoResult({ entity, loading = true }) {
  const memizedMessage = useMemo(() => {
    if (entity === ENTITY_TYPES.item) {
      return "Loading Items";
    } else if (entity === ENTITY_TYPES.planogram) {
      return "Loading Planograms";
    } else {
      return "Loading Departments";
    }
  }, [entity]);

  return (
    <Paper sx={NoResultPaperSx}>
      {!loading ? (
        <>
          <SearchOffOutlinedIcon fontSize="small" />
          <span className="result-msg">No results found</span>
        </>
      ) : (
        <>
          <CircularProgress
            size={20}
            thickness={4}
            color="inherit"
            sx={{ marginRight: "4px" }}
          />
          <span className="result-msg">{memizedMessage}</span>
        </>
      )}
    </Paper>
  );
}

export default memo(CustomNoResult);
